import React from 'react'
import { Route } from 'react-router-dom'
import { baseUrl } from '../../config/endpoints'
import customFieldsReducer from './redux/customFields'
import fieldTypesAndLocations from './redux/fieldTypesAndLocations'
import Secure from '../../containers/Secure'
import { asyncComponent } from 'tr-components/AsyncComponent'

const AsyncFields = asyncComponent(() => import('./Containers/CustomFields'))

export default Object.freeze({
  name: 'CustomFields',
  permission: 'CUSTOM_FIELDS_ALL',

  getRoutes: (basePath) => (
    <Route
      key="CustomField"
      path={`${basePath}/fields`}
      render={({ location, match }) => (
        <Secure hasOne={['CUSTOM_FIELDS_ALL']}>
          <Route component={AsyncFields} path={match.path} />
        </Secure>
      )}
    />
  ),

  getNavLink: (clientId) => undefined,

  reducers: {
    fields: customFieldsReducer,
    fieldsInfo: fieldTypesAndLocations
  }
})

export const listUrl = (clientId) => `${baseUrl}/clients/${clientId}/fields`
export const createUrl = (clientId) => `${baseUrl}/clients/${clientId}/fields`



// WEBPACK FOOTER //
// ./src/modules/CustomFields/index.js